/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { SettingsSlidersH2Icon16Light } from './SettingsSlidersH2Icon16Light';
import { SettingsSlidersH2Icon16Regular } from './SettingsSlidersH2Icon16Regular';
import { SettingsSlidersH2Icon16Solid } from './SettingsSlidersH2Icon16Solid';
import { SettingsSlidersH2Icon20Light } from './SettingsSlidersH2Icon20Light';
import { SettingsSlidersH2Icon20Regular } from './SettingsSlidersH2Icon20Regular';
import { SettingsSlidersH2Icon20Solid } from './SettingsSlidersH2Icon20Solid';
import { SettingsSlidersH2Icon24Regular } from './SettingsSlidersH2Icon24Regular';
import { SettingsSlidersH2Icon24Solid } from './SettingsSlidersH2Icon24Solid';
import { SettingsSlidersH2Icon32Regular } from './SettingsSlidersH2Icon32Regular';
import { SettingsSlidersH2Icon64Regular } from './SettingsSlidersH2Icon64Regular';
var sizes = {
    16: {
        light: SettingsSlidersH2Icon16Light,
        regular: SettingsSlidersH2Icon16Regular,
        solid: SettingsSlidersH2Icon16Solid,
    },
    20: {
        light: SettingsSlidersH2Icon20Light,
        regular: SettingsSlidersH2Icon20Regular,
        solid: SettingsSlidersH2Icon20Solid,
    },
    24: {
        regular: SettingsSlidersH2Icon24Regular,
        solid: SettingsSlidersH2Icon24Solid,
    },
    32: {
        regular: SettingsSlidersH2Icon32Regular,
    },
    64: {
        regular: SettingsSlidersH2Icon64Regular,
    },
};
export var SettingsSlidersH2Icon = forwardRef('SettingsSlidersH2Icon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
